/**
 * Custom Javascript Code for PROfertil menu.
 *
 * @author Eberhard Lauth
 *
 */
( function ( $ ) {

    /* Hide Child pages when not on child page*/
    if($('body').hasClass('page-child')) {
        $('.child-pages-wrapper').show();
    } else {
        $('.child-pages-wrapper').hide();
    }

    /* Menu icon change for PROfertil Hamburger menu */

    $(document).ready(function() {
        $('.hamburger-toggler').addClass('closed');
    });
    $(document).on('on.zf.toggler', function () {
        if ($('.hamburger-toggler').hasClass('closed') ) {
            $('.hamburger-toggler').removeClass('closed').addClass('opened');
            $('a.profertil-hamburger i.material-icons').removeClass('md-menu').addClass('md-close');
        }
    });
    $(document).on('off.zf.toggler', function () {
        if ($('.hamburger-toggler').hasClass('opened') ) {
            $('.hamburger-toggler').removeClass('opened').addClass('closed');
            $('a.profertil-hamburger i.material-icons').removeClass('md-close').addClass('md-menu');
        }
    });
} )( jQuery );
